import { Provider } from 'react-redux'
import PropTypes from 'prop-types'

import { configureStore } from 'lmcv/redux/store'
import { ConfigureInterceptor } from 'lmcv/modules/interceptors'

import { App } from './containers/App'
import { Carousel } from './containers/Carousel'

ConfigureInterceptor()
const store = configureStore()

function LoyaltyCarousel ({ widget }) {
  return (
    <Provider store={store}>
      <App widget={widget}>
        <Carousel />
      </App>
    </Provider>
  )
}

LoyaltyCarousel.propTypes = {
  widget: PropTypes.shape({
    lazyLoadingUrl: PropTypes.string.isRequired
  }).isRequired
}

export default LoyaltyCarousel
